var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M100,74.2c0-15.1,12.3-27.3,27.4-27.3c15.1,0,27.4,12.2,27.4,27.3s-12.3,27.3-27.4,27.3C112.2,101.5,100,89.3,100,74.2 M192.5,74.2c0-35.5-28.9-64.2-64.4-64.2c-35.6,0-64.4,28.7-64.4,64.2c0,35.4,64.4,118.2,64.4,118.2S192.5,109.7,192.5,74.2 M181.1,127.9l-45.1,70c0,0-4.3,2.5-8,2.5c-3.7,0-7.3-2.5-7.3-2.5l-46.5-69.5l-53.5,20.2v95.3l52.7-22.3l55.7,24.4l53.5-24.9l52.7,24.9v-97.4L181.1,127.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/addressIcon.6707823a7350b55da42d62145ca9359d.svg";
export { ForwardRef as ReactComponent };